import { InjectionToken } from '@angular/core';

export const RedirectAfterLoginUrl = new InjectionToken<string>('Redirect after login url');
